export default {"src":"/_next/static/media/facilityIcon.1da87feb.svg","height":31,"width":32,"blurWidth":0,"blurHeight":0};